import {makeAutoObservable} from "mobx"
import React from "react"
import {MarkupByCategoryTree} from "../../../api/PriceSettingsApi"
import MarkUp from "./MarkUp"
import "./CategoryWithMarkUp.scss"

export default class CategoryWithMarkUp {
    _children: CategoryWithMarkUp[] = []
    _id: number
    _name: string
    _hasChildren: boolean
    _price: MarkUp
    _oldPrice: MarkUp
    _premiumPrice: MarkUp

    constructor(markupByCategoryTree: MarkupByCategoryTree) {
        this._id = +markupByCategoryTree.id
        this._name = markupByCategoryTree.name
        for (const child of Object.values(markupByCategoryTree.categories)) {
            this._children.push(new CategoryWithMarkUp(child))
        }
        this._hasChildren = this._children.length > 0
        this._price = new MarkUp(markupByCategoryTree.markups.price, this._hasChildren)
        this._oldPrice = new MarkUp(markupByCategoryTree.markups.old_price, this._hasChildren)
        this._premiumPrice = new MarkUp(markupByCategoryTree.markups.premium_price, this._hasChildren)
        const showChildren = window.localStorage.getItem("CategoryWithMarkUp" + this._id)
        if (showChildren) {
            this._showChildren = showChildren === "Y"
        } else {
            this._showChildren = false
        }
        if (+this._id === 0) {
            this.showChildren = true
        }
        makeAutoObservable(this)
    }

    private _showChildren: boolean

    get showChildren(): boolean {
        return this._showChildren
    }

    set showChildren(value: boolean) {
        this._showChildren = value
        window.localStorage.setItem("CategoryWithMarkUp" + this._id, this._showChildren ? "Y" : "N")

    }

    get components() {
        return <React.Fragment>
            <div className={"category-row flexbox full-width bordered-bottom"}>
                <div className={"category-row__name wide custom-px-16 custom-py-12 "} style={{width: '35%'}}>
                    {this._hasChildren &&
                    <span className={`children-toggler ${this._showChildren && "show"} custom-px-4 cursor-pointer`}
                          onClick={() => this.showChildren = !this.showChildren}>
                        </span>
                    }
                    {this._name}
                </div>
                {this._price.controller}
                {this._oldPrice.controller}
                {this._premiumPrice.controller}
            </div>
            {this._hasChildren && this._showChildren && <div style={{paddingLeft: 10}}>
                {this._children.map((markup, index) => <React.Fragment key={index}>
                    {markup.components}
                </React.Fragment>)}
            </div>}
        </React.Fragment>
    }
}